class cOptionsNotifications {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elSaveNotificationsOptionsBtn = $('#save-notifications-options-btn');
        this.elEditNotificationsOptionsForm = $('#edit-notification-options-form');
        elSaveNotificationsOptionsBtn.click(function (e) {
            return self.onEditNotificationsOptionsBtnClick(this, e);
        });
    }
    onEditNotificationsOptionsBtnClick(btn, e) {
        $(btn).button('loading');
        $(this.elEditNotificationsOptionsForm).ajaxSubmit({
            url: URL_ADMIN + '/options/main/updatenotifications',
            type: 'post',
            dataType: 'json',
            success: function (response, statusText, xhr, el) {
                $(btn).button('reset');
                if (response.success) {
                    notify.success(response.message);
                    setTimeout(function () {
                    }, 2000);
                }
                else {
                    notify.error(response.errors[0]);
                }
            },
            error: function (jqXHR) {
                return ajaxErrorCallback(jqXHR, btn);
            },
        });
        return false;
    }
}
